import { render } from "./CreateCompany.vue?vue&type=template&id=1821dae5"
import script from "./CreateCompany.vue?vue&type=script&lang=js"
export * from "./CreateCompany.vue?vue&type=script&lang=js"
script.render = render

export default script